import React from 'react';
import {TicketTable} from '../../components/Settings/ConfigurationsTable/Ticket';

export const TicketConfiguration = () => {
  return <TicketTable />;
};
